import { IRegisterRequest } from "pages/Auth/services/typings";
import RestAPIClient from "services/RestAPIClient";
import { get, omit } from "lodash";
import { resizeImage } from "utils/images";
import { IBank } from "../components/Contract/components/BankSelect/services/typings";

class RegisterService extends RestAPIClient {
  constructor() {
    super("sso", false);
  }

  getBank = async (opts?: { token?: string }): Promise<IBank[]> => {
    const res = await this.get(
      "/contract/filter/banks/q",
      {
        limit: 9999,
        offset: 0,
      },
      opts
    );
    return res.data;
  };

  isWhitelist = async (opts: {
    token: string;
  }): Promise<{ has_account: boolean; login_err?: string }> => {
    const res = await this.get("/whitelist", undefined, opts);
    return res.data;
  };

  isEmailExist = async ({
    email,
    register,
    token,
  }: {
    email: string;
    register: string;
    token: string;
  }): Promise<{ error?: string; success: boolean }> => {
    const res = await this.get(
      "/register/verify",
      { email, register },
      { token }
    );
    return res;
  };

  getContractConstant = async (opts?: { token?: string; kind?: string }) => {
    const { kind = "", ...rest } = opts || {};
    const res = await this.get(
      `/contract/constant?kind=${kind}`,
      undefined,
      rest
    );
    return res.data;
  };

  register = async (req: IRegisterRequest, opts?: { token?: string }) => {
    const { user_info, contract, register } = req;
    const formData = new FormData();
    formData.append("user_info", JSON.stringify(user_info));
    formData.append(
      "contract",
      JSON.stringify({
        ...contract,
        contract_kyc: {
          id_number: contract.contract_kyc?.id_number,
          issued_on: contract.contract_kyc?.issued_on,
        },
      })
    );
    const processImage = async (file?: File) => {
      if (!file) return null;
      try {
        const res = await resizeImage({ file, maxSize: 1024 });
        return res;
      } catch (e) {
        return file;
      }
    };
    const [
      id_card_front_face,
      id_card_back_face,
      power_attorney,
      enterprise_cert,
      business_household_cert,
    ] = await Promise.all([
      processImage(contract?.contract_kyc?.id_card_front_face),
      processImage(contract?.contract_kyc?.id_card_back_face),
      processImage(contract?.contract_kyc?.power_attorney),
      processImage(contract?.contract_kyc?.enterprise_cert),
      processImage(contract?.contract_kyc?.business_household_cert),
    ]);
    const kyc = {
      id_card_front_face,
      id_card_back_face,
      power_attorney,
      enterprise_cert,
      business_household_cert,
    };
    for (const key in kyc) {
      const img = get(kyc, key);
      if (!!img) formData.append(key, img);
    }
    await this.post(`/register?register=${register}`, formData, opts);
  };
}

export default new RegisterService();
